import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
type PaneType = 'left' | 'right';
@Component({
  selector: 'app-my-slide-panel',
  templateUrl: './my-slide-panel.component.html',
  styleUrls: ['./my-slide-panel.component.scss'],
    animations: [
        trigger('slide', [
            state('left', style({ transform: 'translateX(0)' })),
            state('right', style({ transform: 'translateX(-50%)' })),
            transition('* => *', animate(300))
        ])
    ]

})
export class MySlidePanelComponent {
    @Input() activePane: PaneType = 'left';

}
